import { Storage } from '@ionic/storage'

const store = new Storage({
    name: process.env.REACT_APP_STORAGE_NAME
})

export const GetListing = async ()=> {
    const storage = await store.create();
    const access_token = await storage.get(`access_token`)
    const response = await fetch(`${process.env.REACT_APP_API_URL}/transactions/listing`, {
        method: "GET",
        credentials: "include",
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json',
        }
    })
    const result = await response.json()
    if (response.status === 200) {
        return result
    } else {
        throw new Error(result.message)
    }
}